import React from "react";
import { Box, Typography } from "@mui/material";
import {
  resolveThemeBackground,
  resolveColorPair,
  resolveMatchGallery,
  normalizeTheme,
} from "./themeEngine";
import { galleryThemeAsMatchGallerySource } from "../GalleryTheme/galleryTheme";

// Live preview for the ThemesPopup's Business Box section. Small and
// self-contained (unlike GalleryThemePreview, which renders the real
// Collections/Wheel-listing chrome) -- Business Box has no equivalent
// full-page surface to preview, just the card DataBox.jsx renders. Resolution
// mirrors DataBox exactly: resolveMatchGallery(theme, galleryTheme,
// isOnGalleryPage) -> resolveThemeBackground/resolveColorPair. The editor
// always previews "as shown on the Gallery page" (isOnGalleryPage=true) since
// that's the ONLY place Match-the-Gallery has any visible effect.
//
// `galleryTheme` (profile.gallery_theme) is persisted in
// GalleryTheme/galleryTheme.js's OWN legacy shape, not the token shape
// resolveMatchGallery expects -- bridge it first (batch-proof-fe-3d5e0fc5),
// same as DataBox.jsx.
const BusinessBoxThemePreview = ({ theme, galleryTheme }) => {
  const effective = resolveMatchGallery(
    theme,
    galleryThemeAsMatchGallerySource(galleryTheme),
    true
  );
  const bg = resolveThemeBackground(effective) || "#F6F7F9";
  const card = resolveColorPair(normalizeTheme(effective).card);
  const button = resolveColorPair(normalizeTheme(effective).button);
  const radius = normalizeTheme(effective).corner_rounding ?? 12;

  return (
    <Box
      data-testid="businessbox-theme-preview"
      sx={{
        p: 3,
        borderRadius: "8px",
        border: "1px solid #E1E1E1",
        background: "#FAFAFA",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <Box
        data-testid="businessbox-theme-preview-card"
        sx={{
          width: 280,
          minHeight: 180,
          p: 2,
          borderRadius: `${radius}px`,
          background: bg,
          border: card.border ? `1px solid ${card.border}` : "1px solid #E1E1E1",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <Box
          sx={{
            borderRadius: `${Math.max(radius - 4, 0)}px`,
            background: card.fill || "#FFFFFF",
            color: card.text || "#0F0F0F",
            p: 2,
            flex: 1,
          }}
        >
          <Typography sx={{ fontWeight: 700, fontSize: 16, fontFamily: "DM Sans" }}>
            Your Business
          </Typography>
          <Typography sx={{ fontSize: 13, fontFamily: "DM Sans", opacity: 0.8 }}>
            Business Box preview
          </Typography>
        </Box>
        <Box
          data-testid="businessbox-theme-preview-button"
          sx={{
            mt: 2,
            alignSelf: "flex-start",
            borderRadius: `${Math.max(radius - 4, 0)}px`,
            background: button.fill || "#9B5AF8",
            color: button.text || "#FFFFFF",
            border: button.border ? `1px solid ${button.border}` : "none",
            px: 2,
            py: 1,
            fontSize: 13,
            fontWeight: 600,
            fontFamily: "DM Sans",
          }}
        >
          Visit
        </Box>
      </Box>
    </Box>
  );
};

export default BusinessBoxThemePreview;
